export default "__VITE_ASSET__BM$MZWqg__"